import Link from 'components/Basic/Link/Link';
import { SocialMediaItemApi } from 'graphql/generated';
import useTranslation from 'next-translate/useTranslation';
import twMerge from 'utils/twMerge';

export const SocialMediaIcon: FC<SocialMediaItemApi> = ({
    mainImage,
    mainImageTitle,
    hoverImage,
    hoverImageTitle,
    linkActionTitle,
    socialMediaName,
    url,
}) => {
    const { t } = useTranslation();

    const fallbackLinkActionTitle = socialMediaName
        ? `${socialMediaName} - ${t('open social media page')}`
        : t('open social media page');

    if (!mainImage) {
        return null;
    }

    return (
        <Link linkType="external" href={url} target="_blank" title={linkActionTitle ?? fallbackLinkActionTitle}>
            <div
                role="img"
                aria-label={t('Social media icon')}
                className={twMerge(
                    'relative h-12 w-12 overflow-hidden transition-transform duration-300 hover:scale-110',
                )}
            >
                <img
                    src={mainImage}
                    alt={mainImageTitle ?? t('Social media icon - main image')}
                    className="absolute inset-0 h-full w-full object-contain transition-opacity duration-300"
                />
                {hoverImage && (
                    <img
                        src={hoverImage}
                        alt={hoverImageTitle ?? t('Social media icon - hover image')}
                        className="absolute inset-0 h-full w-full object-contain opacity-0 transition-opacity duration-300 hover:opacity-100"
                    />
                )}
            </div>
        </Link>
    );
};
